
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

export default {
name: 'ApplyTryPage',
components: {
XInput,
XButton,
Group,
Cell,
Msg,
CheckIcon
},
data () {
return {
formParam: {
mobile: '',
contact: '',
companyName: '',
email: '',
hzTag: 0,
bghTag: 0,
hdTag: 0
},
hzTag: false,
bghTag: false,
hdTag: false,
submitSuccess: false,
buttons: [{
type: 'default',
text: '关闭',
onClick: this.closePage.bind(this)
}]
}
},
methods: {
closePage: function () {


},
submitApply: function () {
let that = this
let url = '/wxapi/user/submitApplyTryAll'
that.formParam.hzTag = that.hzTag ? 1 : 0
that.formParam.bghTag = that.bghTag ? 1 : 0
that.formParam.hdTag = that.hdTag ? 1 : 0
if (!that.hzTag && !that.bghTag && !that.hdTag) {
that.$Msgbox.alert('请选择至少一个您感兴趣的产品！', '异常提示')
return
}
if (that.$Utils.IsEmpty(that.formParam.contact)) {
that.$Msgbox.alert('请填写姓名！', '异常提示')
return
}
if (that.$Utils.IsEmpty(that.formParam.mobile)) {
that.$Msgbox.alert('请填写手机号！', '异常提示')
return
}
this.$axios.post(url, {}, {params: that.formParam}).then(function (res) {
if (res.meta.success) {
that.submitSuccess = true
} else {
console.error(res.meta.message)
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}).catch(function (error) {
console.info(error)
})
},
hzClick: function () {
console.log('hzClick')
/* let that = this
that.bghTag = that.hzTag ? false : that.bghTag
that.hdTag = that.hzTag ? false : that.hdTag */
},
bghClick: function () {
/* let that = this
that.hzTag = that.bghTag ? false : that.hzTag
that.hdTag = that.bghTag ? false : that.hdTag */
},
hdClick: function () {
/* let that = this
that.bghTag = that.hdTag ? false : that.bghTag
that.hzTag = that.hdTag ? false : that.hzTag */
}
}
}



// WEBPACK FOOTER //
// ./src/pages/user/ApplyTryPageGSCMS.vue